import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import SEOHead from "../components/shared/SEOHead";

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Cookie Policy | Hitech Transit"
        description="Hitech Transit cookie policy. How we use cookies and similar technologies on our website."
        canonical="/cookies"
      />
      <Header />
      
      <main className="pt-20">
        <section className="bg-[#0F172A] py-16">
          <div className="container-max px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-['Outfit'] font-bold text-white">Cookie Policy</h1>
          </div>
        </section>

        <section className="section-padding">
          <div className="container-max">
            <div className="max-w-3xl mx-auto">
              <p className="text-sm text-slate-500 mb-8">Last updated: January 2026</p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">What Are Cookies</h2>
              <p className="text-slate-600 mb-4">
                Cookies are small text files stored on your device when you visit our website. They help us 
                provide you with a better experience and understand how you use our site.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">Cookies We Use</h2>
              
              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3">Essential Cookies</h3>
              <p className="text-slate-600 mb-4">
                Required for the website to function properly. These include session cookies and authentication cookies.
              </p>

              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3">Analytics Cookies</h3>
              <p className="text-slate-600 mb-4">
                Help us understand how visitors interact with our website, allowing us to improve our services.
              </p>

              <h3 className="text-lg font-semibold text-[#0F172A] mt-6 mb-3">Functional Cookies</h3>
              <p className="text-slate-600 mb-4">
                Remember your preferences and settings to provide a personalized experience.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">Managing Cookies</h2>
              <p className="text-slate-600 mb-4">
                You can control and manage cookies through your browser settings. Note that disabling certain 
                cookies may affect the functionality of our website.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">Third-Party Cookies</h2>
              <p className="text-slate-600 mb-4">
                We use services like Stripe and PayPal for payments, which may set their own cookies. 
                Please refer to their respective privacy policies for more information.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">Contact</h2>
              <p className="text-slate-600 mb-4">
                If you have questions about our cookie policy, please contact us at hello@hitechtransit.com.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CookiesPage;
